<template>
  <div id="experience-page">
    <ParallaxHeader :headline="'Experience'" :slogan="''"/>
    <v-container fluid grid-list-xl>
      <v-layout row wrap justify-center>
        <v-flex xs12 lg8 xl6>
        <!-- <v-card flat color="grey lighten-2"> -->
          <v-tabs color="grey lighten-2" left>
            <v-tab v-for="(experience, experienceIndex) in experienceData" :key="experienceIndex" @click="showExperienceItem(experienceIndex, experience)">
              {{ experience.title }}
            </v-tab>
          </v-tabs>
          <!-- <v-container> -->
            <v-layout row wrap v-if="experienceDetails.length === 0 || experienceData[index].title.toLowerCase() === 'videos'">
              <!-- <v-flex x12 md8 lg6> -->
              
              <!-- <v-flex x12 md8 lg6> -->
                <v-flex v-if="experienceData[index].title.toLowerCase() !== 'videos'" xs12 md6>
                  <div class="experience-div" dense color="grey lighten-2">
                    <h2 class="display-2">{{ experienceData[index].title }}</h2>
                    <hr class="buzz-hr">
                    <p v-for="(para, i) in experienceData[index].content.split('\n')" :key="i" class="content-text">{{ para }}</p> 
                  </div>
                </v-flex>
                <v-flex v-if="experienceData[index].title.toLowerCase() !== 'videos'" xs12 md6>
                  <v-card v-if="experienceData[index].image">
                    <v-card-media :src="'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + experienceData[index].image" height="70vh">
                    </v-card-media>
                  </v-card>
                </v-flex>
                <v-flex xs12 v-else>
                  <div class="experience-div" dense color="grey lighten-2">
                    <h2 class="display-2">{{ experienceData[index].title }}</h2>
                    <hr class="buzz-hr">
                    <!-- <p v-for="(para, i) in experienceData[index].content.split('\n')" :key="i" class="content-text">{{ para }}</p>  -->
                    <v-container fluid fill-height>
                      <v-layout row wrap>
                        <v-flex
                          v-for="(item, i) in videos"
                          v-bind="{ [`xs${3 * 2}`]: true, [`sm${3}`]: true, [`md${3}`]: true, [`lg${3}`]: true }"
                          :key="i"
                          @click="showVideo(i)"
                        >
                          <v-card hover raised height="150">
                            <v-card-media
                            :src="'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + item.thumbnail"
                            height="150"
                            >
                            </v-card-media>
                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-container>
                    <BuzzTube v-if="showVideoGallery" @showVideo="showVideoGallery=!showVideoGallery" :videos="videos" :activeIndex="videoIndex"/>
                  </div>
                </v-flex>
            </v-layout>
            <v-layout row wrap v-else>
              <v-flex xs12 md3>
                <v-card>
                <v-list class="grey lighten-3 hidden-sm-and-down"> 
                  <v-list-tile v-for="(item, itemIndex) in experienceDetails" :key="itemIndex" @click="showDetailsTab(itemIndex, item.id)">
                    <v-list-tile-action>
                      <v-icon v-if="paraIndex === itemIndex">star</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-title v-text="item.headline" style="text-transform: uppercase;font-size: 10pt;font-weight: bold;color:#676767;margin-left: -20px;"></v-list-tile-title>
                  </v-list-tile>
                </v-list>
                <!-- <v-card-text class="hidden-sm-and-down">
                  <div><span style="font-weight: bold;">Gross Realisation</span><p>{{ projectDetails[0].project.gross_realisation }}</p></div>
                  <div><span style="font-weight: bold;">Date</span><p>{{ projectDetails[0].project.completed_on | yearFormat }}</p></div>
                </v-card-text> -->
                <!-- <v-card-actions class="hidden-sm-and-down">
                  <v-btn flat color="orange" icon><v-icon>share</v-icon></v-btn>
                  <v-btn flat color="orange" icon><v-icon>fa-map-marker</v-icon></v-btn>
                </v-card-actions> -->
                </v-card>
              </v-flex>
              <v-flex xs12 md9>
                <!-- <p class="headline">{{ projectDetails.name }}</p> -->
                <!-- <div v-for="(item, itemIndex) in projectDetails.paragraphs" :key="itemIndex"> -->
                <div>
                  <p class="display-1">{{ experienceDetails[paraIndex].headline}} 
                    <div class="hidden-md-and-up">
                      <!-- <v-btn flat color="orange" icon><v-icon>share</v-icon></v-btn> -->
                      <!-- <v-btn flat color="orange" icon><v-icon>fa-map-marker</v-icon></v-btn> -->
                      <v-menu offset-y>
                        <v-icon slot="activator">fa-ellipsis-h</v-icon>
                        <v-list class="grey lighten-2"> 
                          <v-list-tile v-for="(item, itemIndex) in experienceDetails" :key="itemIndex" @click="showDetailsTab(itemIndex, item.id)">
                            <v-list-tile-action>
                              <v-icon v-if="paraIndex === itemIndex">star</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-title v-text="item.headline" style="text-transform: uppercase;font-size: 10pt;font-weight: bold;color:#676767;"></v-list-tile-title>
                          </v-list-tile>
                        </v-list> 
                      </v-menu>
                    </div>
                  </p>
                  <hr class="buzz-hr">
                  <!-- <v-card v-if="paraIndex === 0" flat>
                    <v-card-media
                      height="50vh">
                      <img :src="'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + experienceDetails[paraIndex].experience.image"/>
                    </v-card-media>
                  </v-card> -->
                  <!-- <p v-for="(desc, descIndex) in projectDetails[paraIndex].description" :key="descIndex" class="content-text">{{ desc }}</p> -->
                  <div v-if="!showDetailsGallery">
                    <p v-for="(para, i) in experienceDetails[paraIndex].content.split('\n')" :key="i" class="content-text">{{ para }}</p> 
                    <v-card-media
                      :src="'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + experienceData[index].image"
                      height="35vh">
                    </v-card-media>
                  </div>
                  <ImageGallery :thumbnail="detailsGallery" v-else/>
                  <v-spacer></v-spacer>
                </div>
              </v-flex>
            </v-layout>
          <!-- </v-container> -->
          <!-- </v-card> -->
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import ParallaxHeader from '@/components/ParallaxHeader'
import ImageGallery from '@/components/ImageGallery'
import BuzzTube from '@/components/BuzzTube'
import Api from '@/api'

export default {
  data () {
    return {
      experienceData: [{'title': '', 'content': ''}],
      index: 0,
      paraIndex: 0,
      imageGallery: [],
      detailsGallery: [],
      showDetailsGallery: false,
      experienceDetails: [],
      videos: [],
      showVideoGallery: false
    }
  },
  components: {
    ParallaxHeader,
    ImageGallery,
    BuzzTube
  },
  beforeMount () {
    this.getExperienceData()
  },
  methods: {
    getExperienceData () {
      const path = '/experience'
      const auth = {
        username: this.authUsername,
        password: this.authPassword
      }
      Api.get(path, auth)
        .then(response => {
          if (response.data.status === 0) {
            this.experienceData = response.data.experience
            // this.experienceDetails = response.data.experience_details
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal(error.toString().substring(0, 100))
        })
    },
    getExperienceDetailsData (detailsID) {
      const path = '/experience/' + detailsID
      const auth = {
        username: this.authUsername,
        password: this.authPassword
      }
      Api.get(path, auth)
        .then(response => {
          if (response.data.status === 0) {
            this.experienceDetails = response.data.experience_details
            this.getGalleryData(detailsID)
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal(error.toString().substring(0, 100))
        })
    },
    showExperienceItem (index, experience) {
      this.paraIndex = 0
      this.detailsGallery = []
      this.imageGallery = []
      this.index = index
      if (experience.title.toLowerCase() !== 'videos') {
        this.getExperienceDetailsData(this.experienceData[index].id)
      } else {
        this.getVideosData()
      }
    },
    showDetailsTab (itemIndex, detailsID) {
      this.detailsGallery = []
      this.imageGallery.forEach((el) => {
        if (el.experience_details.id === detailsID) {
          // this.detailsGallery.push('https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + el.name)
          // this.detailsGallery.push({ 'image': 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + el.name, 'experience': el.experience.name, 'experience_details': el.experience_details.headline })
          this.detailsGallery.push({ 'image': 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + el.name, 'project': el.experience.title, 'project_details': el.experience_details.headline })
        }
      })
      if (this.detailsGallery.length > 0) {
        this.showDetailsGallery = true
      } else {
        this.showDetailsGallery = false
      }
      this.paraIndex = itemIndex
    },
    getGalleryData (itemID) {
      this.detailsGallery = []
      const path = '/experience-image-gallery/' + itemID
      const auth = {
        username: this.authUsername,
        password: this.authPassword
      }
      Api.get(path, auth)
        .then(response => {
          if (response.data.status === 0) {
            this.imageGallery = response.data.imagegallery
            this.imageGallery.forEach((el) => {
              if (el.experience_details.id === this.experienceDetails[this.paraIndex].id) {
                this.detailsGallery.push({ 'image': 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + el.name, 'project': el.experience.title, 'project_details': el.experience_details.headline })
              }
            })
            if (this.detailsGallery.length > 0) {
              this.showDetailsGallery = true
            } else {
              this.showDetailsGallery = false
            }
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal(error.toString().substring(0, 100))
        })
    },
    getVideosData () {
      const path = '/video-gallery/experience'
      const auth = {
        username: this.authUsername,
        password: this.authPassword
      }
      Api.get(path, auth)
        .then(response => {
          if (response.data.status === 0) {
            this.videos = response.data.videos
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal(error.toString().substring(0, 100))
        })
    },
    showVideo (index) {
      this.videoIndex = index
      this.showVideoGallery = !this.showVideoGallery
    }
  }
}
</script>

<style scoped>
#experience-page {
  font-family: 'Lato', sans-serif;
}
#page-name {
  font-size: 3.5vmax;
  font-family: 'Vollkorn', serif;
}
.container {
  /*min-height: 58vh;*/
}
.inline-buzz-hr {
  border-top: 1px solid #ccc;
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/ExperiencePage.vue